<p-toast position="bottom-right"></p-toast>

<!-- DIALOG DE PERMISOS - BOTONES Y CAMPOS -->
<p-dialog
  *ngIf="currentView === 'botones-campos'"
  [(visible)]="displayPermissionsDialog"
  [style]="{ width: '900px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closePermissionsDialog()"
  [header]="'Permisos de Botones y Campos - Rol: ' + (selectedRol?.description || '')"
>
  <div class="permissions-dialog-content">
    <!-- Buscador de permisos -->
    <div class="mb-3">
      <span class="p-input-icon-left w-100">
        <i class="pi pi-search"></i>
        <input
          #permissionsSearch
          pInputText
          type="text"
          [(ngModel)]="permissionsSearchText"
          (input)="dtPermissions?.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Buscar en permisos..."
          class="p-inputtext-sm w-100"
        />
      </span>
    </div>

    <p-table
      #dtPermissions
      [value]="permissionsData"
      [loading]="loadingPermissions"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 30]"
      [globalFilterFields]="['id', 'codigo', 'nombre', 'item']"
      styleClass="p-datatable-gridlines"
      [scrollable]="true"
      [scrollHeight]="'400px'"
      responsiveLayout="scroll"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} permisos"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="th-prime">ID</th>
          <th class="th-prime">Código</th>
          <th class="th-prime">Nombre</th>
          <th class="th-prime">Item</th>
          <th class="th-prime" style="text-align: center; min-width: 180px;">Estado</th>
          <th class="th-prime" style="text-align: center; min-width: 150px;">Requerido</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-permission>
        <tr>
          <td class="td-prime">{{ permission.id }}</td>
          <td class="td-prime">{{ permission.codigo }}</td>
          <td class="td-prime">{{ permission.nombre }}</td>
          <td class="td-prime">{{ permission.item }}</td>
          <td class="td-prime text-center">
            <p-dropdown
              [options]="permissionStates"
              [(ngModel)]="permission.currentState"
              (onChange)="onPermissionStateChange(permission, $event)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [style]="{ width: '100%', minWidth: '160px' }"
              placeholder="Seleccione estado"
            >
              <ng-template let-option pTemplate="item">
                <div class="d-flex align-items-center gap-2">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                <div class="d-flex align-items-center gap-2" *ngIf="option">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </td>
          <td class="td-prime text-center">
            <p-dropdown
              [options]="requiredStates"
              [(ngModel)]="permission.currentRequired"
              (onChange)="onRequiredStateChange(permission, $event)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [style]="{ width: '100%', minWidth: '130px' }"
              placeholder="Seleccione"
            >
              <ng-template let-option pTemplate="item">
                <div class="d-flex align-items-center gap-2">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                <div class="d-flex align-items-center gap-2" *ngIf="option">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="text-center td-prime">
            <span *ngIf="permissionsData.length === 0 && !loadingPermissions">No hay permisos asignados</span>
            <p-progressSpinner *ngIf="loadingPermissions" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- DIALOG DE PERMISOS - MÓDULOS (Vista Principal) -->
<p-dialog
  *ngIf="currentView === 'menus-submenus'"
  [(visible)]="displayPermissionsDialog"
  [style]="{ width: '800px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closePermissionsDialog()"
  [header]="'Módulos del Rol: ' + (selectedRol?.description || '')"
>
  <div class="permissions-dialog-content">
    <!-- Buscador de módulos -->
    <div class="mb-3">
      <span class="p-input-icon-left w-100">
        <i class="pi pi-search"></i>
        <input
          #permissionsSearchMenus
          pInputText
          type="text"
          [(ngModel)]="permissionsSearchText"
          (input)="dtPermissionsMenus?.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Buscar módulo..."
          class="p-inputtext-sm w-100"
        />
      </span>
    </div>

    <p-table
      #dtPermissionsMenus
      [value]="menusSubmenusData"
      [loading]="loadingPermissions"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 30]"
      [globalFilterFields]="['moduleName']"
      styleClass="p-datatable-gridlines"
      [scrollable]="true"
      [scrollHeight]="'400px'"
      responsiveLayout="scroll"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} módulos"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="th-prime">ID Módulo</th>
          <th class="th-prime">Nombre del Módulo</th>
          <th class="th-prime" style="text-align: center; min-width: 150px;">Estado</th>
          <th class="th-prime" style="text-align: center; width: 80px;">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-module>
        <tr>
          <td class="td-prime">{{ module.moduleId }}</td>
          <td class="td-prime">
            <div>{{ module.moduleName }}</div>
            <small class="text-muted">{{ module.enabledCount }} de {{ module.totalCount }} habilitados ({{ module.enablePercentage }}%)</small>
          </td>
          <td class="td-prime text-center">
            <p-dropdown
              [options]="menuStates"
              [(ngModel)]="module.currentState"
              (onChange)="onModuleStateChange(module, $event)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [style]="{ width: '100%', minWidth: '140px' }"
              placeholder="Seleccione"
            >
              <ng-template let-option pTemplate="item">
                <div class="d-flex align-items-center gap-2">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                <div class="d-flex align-items-center gap-2" *ngIf="option">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </td>
          <td class="td-prime text-center">
            <button
              pButton
              icon="pi pi-eye"
              class="p-button-rounded p-button-info p-button-text"
              (click)="openMenusDetail(module)"
              pTooltip="Ver menús y submenús"
            ></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center td-prime">
            <span *ngIf="menusSubmenusData.length === 0 && !loadingPermissions">No hay módulos asignados</span>
            <p-progressSpinner *ngIf="loadingPermissions" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- DIALOG DE MENÚS (PADRES) -->
<p-dialog
  [(visible)]="displayMenusDialog"
  [style]="{ width: '900px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeMenusDialog()"
  [header]="'Menús del Módulo: ' + (selectedModule?.moduleName || '')"
>
  <div class="permissions-dialog-content">
    <!-- Buscador de menús -->
    <div class="mb-3">
      <span class="p-input-icon-left w-100">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          [(ngModel)]="menusSearchText"
          (input)="dtMenus?.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Buscar menú..."
          class="p-inputtext-sm w-100"
        />
      </span>
    </div>

    <p-table
      #dtMenus
      [value]="menusData"
      [loading]="loadingPermissions"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 30]"
      [globalFilterFields]="['menuName']"
      styleClass="p-datatable-gridlines"
      [scrollable]="true"
      [scrollHeight]="'400px'"
      responsiveLayout="scroll"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} menús"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="th-prime">ID Permiso</th>
          <th class="th-prime">Nombre del Menú</th>
          <th class="th-prime" style="text-align: center; min-width: 150px;">Estado</th>
          <th class="th-prime" style="text-align: center; width: 80px;">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-menu>
        <tr>
          <td class="td-prime">{{ menu.permissionModuleId }}</td>
          <td class="td-prime">
            <div>
              <i class="pi pi-folder" style="color: #2196F3; margin-right: 8px;"></i>
              <span style="font-weight: 600;">{{ menu.menuName }}</span>
            </div>
            <small class="text-muted" *ngIf="menu.childrenCount > 0">
              {{ menu.enabledChildrenCount }} de {{ menu.childrenCount }} submenús habilitados
            </small>
            <small class="text-muted" *ngIf="menu.childrenCount === 0">
              Sin submenús
            </small>
          </td>
          <td class="td-prime text-center">
            <p-dropdown
              [options]="menuStates"
              [(ngModel)]="menu.currentState"
              (onChange)="onMenuStateChange(menu, $event)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [style]="{ width: '100%', minWidth: '140px' }"
              placeholder="Seleccione"
            >
              <ng-template let-option pTemplate="item">
                <div class="d-flex align-items-center gap-2">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                <div class="d-flex align-items-center gap-2" *ngIf="option">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </td>
          <td class="td-prime text-center">
            <button
              *ngIf="menu.childrenCount > 0"
              pButton
              icon="pi pi-eye"
              class="p-button-rounded p-button-info p-button-text"
              (click)="openSubmenusDetail(menu)"
              pTooltip="Ver submenús"
            ></button>
            <span *ngIf="menu.childrenCount === 0" class="text-muted" style="font-size: 0.85rem;">-</span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center td-prime">
            <span *ngIf="menusData.length === 0 && !loadingPermissions">No hay menús en este módulo</span>
            <p-progressSpinner *ngIf="loadingPermissions" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- DIALOG DE SUBMENÚS (HIJOS) -->
<p-dialog
  [(visible)]="displaySubmenusDialog"
  [style]="{ width: '900px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeSubmenusDialog()"
  [header]="'Submenús del Menú: ' + (selectedMenu?.menuName || '')"
>
  <div class="permissions-dialog-content">
    <!-- Buscador de submenús -->
    <div class="mb-3">
      <span class="p-input-icon-left w-100">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          [(ngModel)]="submenusSearchText"
          (input)="dtSubmenus?.filterGlobal($any($event.target).value, 'contains')"
          placeholder="Buscar submenú..."
          class="p-inputtext-sm w-100"
        />
      </span>
    </div>

    <p-table
      #dtSubmenus
      [value]="submenusData"
      [loading]="loadingPermissions"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 20, 30]"
      [globalFilterFields]="['menuName']"
      styleClass="p-datatable-gridlines"
      [scrollable]="true"
      [scrollHeight]="'400px'"
      responsiveLayout="scroll"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} submenús"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="th-prime">ID Permiso</th>
          <th class="th-prime">Nombre del Submenú</th>
          <th class="th-prime" style="text-align: center; min-width: 150px;">Estado</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-submenu>
        <tr>
          <td class="td-prime">{{ submenu.permissionModuleId }}</td>
          <td class="td-prime">
            <i class="pi pi-file" style="color: #9E9E9E; margin-right: 8px;"></i>
            {{ submenu.menuName }}
          </td>
          <td class="td-prime text-center">
            <p-dropdown
              [options]="menuStates"
              [(ngModel)]="submenu.currentState"
              (onChange)="onMenuStateChange(submenu, $event)"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [style]="{ width: '100%', minWidth: '140px' }"
              placeholder="Seleccione"
            >
              <ng-template let-option pTemplate="item">
                <div class="d-flex align-items-center gap-2">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                <div class="d-flex align-items-center gap-2" *ngIf="option">
                  <i [class]="option.icon" [style.color]="option.color"></i>
                  <span>{{ option.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center td-prime">
            <span *ngIf="submenusData.length === 0 && !loadingPermissions">No hay submenús</span>
            <p-progressSpinner *ngIf="loadingPermissions" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<div class="card-white">
  <!-- PANTALLA DE SELECCIÓN -->
  <div *ngIf="currentView === 'selection'">
    <div class="card-header mb-4">
      <div class="title-section">
        <h2 class="header-title">Búsqueda de Roles</h2>
      </div>
    </div>
    
    <div class="selection-subtitle">
      <p>Seleccione qué desea actualizar</p>
    </div>

    <div class="selection-cards">
      <div class="selection-card" (click)="selectBotonesCampos()">
        <div class="card-icon">
          <i class="pi pi-th-large"></i>
        </div>
        <h3>Actualizar Botones y Campos</h3>
        <p>Gestionar permisos de botones y campos del sistema</p>
        <button mat-flat-button class="btn-new">
          Seleccionar
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>

      <div class="selection-card" (click)="selectMenusSubmenus()">
        <div class="card-icon">
          <i class="pi pi-bars"></i>
        </div>
        <h3>Actualizar Menús y Submenús</h3>
        <p>Gestionar estructura de navegación y menús</p>
        <button mat-flat-button class="btn-new">
          <mat-icon>arrow_forward</mat-icon>
          Seleccionar
        </button>
      </div>
    </div>
  </div>

  <!-- VISTA DE BOTONES Y CAMPOS -->
  <div *ngIf="currentView === 'botones-campos'">
    <div class="card-header mb-4">
      <div class="title-section">
        <h2 class="header-title">Actualizar Botones y Campos</h2>
      </div>
      <div class="search-section">
        <div class="button-section">
          <span class="p-input-icon-left search-input">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt?.filterGlobal($any($event.target).value, 'contains')"
              placeholder="Buscar..."
              class="p-inputtext-sm"
            />
          </span>
          <button mat-flat-button (click)="backToSelection()" class="btn-back">
            <mat-icon>arrow_back</mat-icon>
            Volver
          </button>
        </div>
      </div>
    </div>

    <p-table
      #dt
      [value]="dataSource"
      [columns]="displayedColumns"
      [paginator]="true"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 20]"
      [scrollable]="true"
      [scrollHeight]="'calc(100vh - 400px)'"
      styleClass="p-datatable-gridlines"
      [resizableColumns]="true"
      [autoLayout]="true"
      responsiveLayout="scroll"
      [loading]="loading"
      [globalFilterFields]="['id', 'description', 'definition', 'userCreated']"
      (onPage)="onPage($event)"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime">
            {{ col.header }}
            <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td *ngFor="let col of displayedColumns" class="td-prime">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'active'">
                <span [class]="rowData[col.field] ? 'badge-success' : 'badge-danger'">
                  {{ rowData[col.field] ? 'Activo' : 'Inactivo' }}
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'dateCreated'">
                {{ rowData[col.field] | date:'dd/MM/yyyy HH:mm' }}
              </ng-container>
              <ng-container *ngSwitchCase="'actions'">
                <div class="d-flex gap-2 justify-content-center">
                  <button
                    pButton
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-info p-button-text"
                    (click)="openPermissions(rowData)"
                    pTooltip="Ver permisos"
                  ></button>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ rowData[col.field] }}
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center td-prime">
            <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
            <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <!-- VISTA DE MENÚS Y SUBMENÚS -->
  <div *ngIf="currentView === 'menus-submenus'">
    <div class="card-header mb-4">
      <div class="title-section">
        <h2 class="header-title">Actualizar Menús y Submenús</h2>
      </div>
      <div class="search-section">
        <div class="button-section">
          <span class="p-input-icon-left search-input">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dt?.filterGlobal($any($event.target).value, 'contains')"
              placeholder="Buscar..."
              class="p-inputtext-sm"
            />
          </span>
          <button mat-flat-button (click)="backToSelection()" class="btn-back">
            <mat-icon>arrow_back</mat-icon>
            Volver
          </button>
        </div>
      </div>
    </div>

    <p-table
      #dt
      [value]="dataSource"
      [columns]="displayedColumns"
      [paginator]="true"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 20]"
      [scrollable]="true"
      [scrollHeight]="'calc(100vh - 400px)'"
      styleClass="p-datatable-gridlines"
      [resizableColumns]="true"
      [autoLayout]="true"
      responsiveLayout="scroll"
      [loading]="loading"
      [globalFilterFields]="['id', 'description', 'definition', 'userCreated']"
      (onPage)="onPage($event)"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.field !== 'actions' ? col.field : null" class="th-prime">
            {{ col.header }}
            <p-sortIcon *ngIf="col.field !== 'actions'" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td *ngFor="let col of displayedColumns" class="td-prime">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'active'">
                <span [class]="rowData[col.field] ? 'badge-success' : 'badge-danger'">
                  {{ rowData[col.field] ? 'Activo' : 'Inactivo' }}
                </span>
              </ng-container>
              <ng-container *ngSwitchCase="'dateCreated'">
                {{ rowData[col.field] | date:'dd/MM/yyyy HH:mm' }}
              </ng-container>
              <ng-container *ngSwitchCase="'actions'">
                <div class="d-flex gap-2 justify-content-center">
                  <button
                    pButton
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-info p-button-text"
                    (click)="openPermissions(rowData)"
                    pTooltip="Ver permisos"
                  ></button>
                </div>
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ rowData[col.field] }}
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" class="text-center td-prime">
            <span *ngIf="dataSource.length === 0 && !loading">No hay datos para mostrar</span>
            <p-progressSpinner *ngIf="loading" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<style>
.selection-subtitle {
  text-align: center;
  margin-bottom: 2rem;
}

.selection-subtitle p {
  color: #6c757d;
  font-size: 1rem;
}

.selection-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  padding: 1rem;
  max-width: 900px;
  margin: 0 auto;
}

.selection-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.selection-card:hover {
  border-color: #007bff;
  box-shadow: 0 8px 16px rgba(0,123,255,0.15);
  transform: translateY(-4px);
}

.card-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background: #007bff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  color: white;
}

.selection-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.75rem;
}

.selection-card p {
  color: #6c757d;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.selection-card button {
  margin-top: 0.5rem;
}

.text-muted {
  color: #6c757d !important;
  font-size: 0.85rem;
}
</style>
